module.exports = __webpack_public_path__ + "img/Fliegen.bb01f816.svg";